<template>
    <div class="checkoutpage">
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
        <loading :active.sync="isLoadingSubmit" :can-cancel="false" :is-full-page="true">
			<div class="checkout_submit_loader">
				<svg viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" width="64" height="64" stroke="#000"><g fill="none" fill-rule="evenodd"><g transform="translate(1 1)" stroke-width="2"><circle stroke-opacity=".25" cx="18" cy="18" r="18"></circle><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.8s" repeatCount="indefinite"></animateTransform></path></g></g></svg>
				<p>We are creating your order. Please wait. Do not refresh.</p>
			</div>
		</loading>
        <header>
            <div class="container">
                <div class="carthead">
                    <div class="cartlogosec">
                        <a href="/"><b-img class="logo" src="/shop/images/rmcoco_new.webp" alt="logo image"></b-img></a>
                    </div>
                    <div class="cartsteps">
                        <ul>
                            <li>
                                <a :class="step1 === true ? 'backcart active' : 'backcart'" href="javascript:;" @click="stepchange(1)">Step 1 - Information<b-img class="backarrow" src="/shop/images/arrow-grey.svg" fluid alt="arrow image"></b-img></a>
                            </li>
                            <li>
                                <a :class="step2 === true ? 'backcart active' : 'backcart'" href="javascript:;" @click="steponevalidation()">Step 2 - Shipping<b-img class="backarrow" src="/shop/images/arrow-grey.svg" fluid alt="arrow image"></b-img></a>
                            </li>
                            <li>
                                <a :class="step3 === true ? 'backcart active' : 'backcart'" href="javascript:;" @click="steptwovalidation()">Step 3 - Payment</a>
                            </li>
                        </ul>
                    </div>
                    <router-link class="backcart" to="/shop/cart"><b-img class="backarrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img> Back to Cart </router-link>
                </div>
            </div>
        </header>
        <div class="maincart">
            <div class="leftcart">
                <div :class="step1 === true ? 'checkoutsteps step1 show' : 'checkoutsteps step1'">
					<h3 class="mobilehead">Step 1 - Information</h3>
                    <b-form class="commonform">
                        <b-row>
                            <b-col>
                                <h3>Contact Information</h3>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <md-field class="forstar">
                                <label>Ordered By</label>
                                <md-input type="text" class="orderby" v-model="form.orderby"></md-input>
                                </md-field>
                            </b-col>
                            <b-col>
                                <md-field class="forstar">
                                <label>Email</label>
                                <md-input type="email" class="email" v-model="form.email"></md-input>
                                </md-field>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <md-field>
                                <label>Po / Sidemark</label>
                                <md-input type="text" class="poside" v-model="form.poside" maxlength="55"></md-input>
                                </md-field>
                            </b-col>
                        </b-row>
                        <hr class="lasthr">
                        <b-row class="mobilesetup">
                            <b-col>
                                <router-link class="backcart" to="/shop/cart"><b-img class="backarrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img> Back to Cart </router-link>
                            </b-col>
                            <b-col>
                                <b-button type="button" @click="steponevalidation()" class="float-right" variant="dark">Continue to step 2</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </div>
                <div :class="step2 === true ? 'checkoutsteps step2 show' : 'checkoutsteps step2'">
					<h3 class="mobilehead">Step 2 - Shipping</h3>
                    <b-form class="commonform">
                        <b-row>
                            <b-col>
                                <h3>Shipping Method</h3>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="md-field md-theme-default forstar">
                                    <label class="setuplabel">Preferred shipping method</label>
                                    <v-select
                                        class="style-chooser shipmethod"
                                        :options="shipmethod"
                                        v-model="form.shipmethod"
                                        :reduce="shipmethod => shipmethod.value"
                                        label="text"
                                        :clearable="false"
                                        :searchable="false"
                                        :disabled="shipdisabled"
                                        @input="getShipping"
                                        placeholder=""
                                    ></v-select>
                                    <p class="error_noti" v-if="shipping_error">{{shipping_error}}</p>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row v-if="isOneFlatEnable == true">
                            <b-col>
                                <div class="oneflat">
                                    <md-checkbox v-model="form.oneflat" value="1" @change="getShippingOneFlat">One Rate - Flat fold </md-checkbox>
                                    <p class="error_noti"><i>Fabric orders shipping via One Rate with FedEx will be flat folded which can lead to wrinkles and are not eligible for returns.</i></p>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <md-field>
                                <label>Special Instructions</label>
                                <md-textarea v-model="form.specialinfo"></md-textarea>
                                </md-field>
                            </b-col>
                        </b-row>
                        <hr>
                        <b-row class="setup">
                            <b-col>
                                <h3>Shipping Address</h3>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
							    <label class="setuplabel">Saved Address</label>
                                <div class="md-field md-theme-default">
                                <v-select
                                    class="style-chooser"
                                    :options="savedadd"
                                    v-model="form.savedaddress"
                                    :reduce="savedadd => savedadd.ADDRESSID"
                                    label="ADDRESS"
                                    :clearable="false"
                                    :searchable="false"
                                    placeholder=""
									@input="getAddress"
                                >
                                    <template slot="option" slot-scope="option">
                                        {{ option.LOCATIONNAME }} {{option.ADDRESS}}
                                    </template>
                                </v-select>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col :class="(this.errors.length)?'error':''">
                                <md-field class="forstar">
                                <label>Full Name</label>
                                <md-input type="text" class="fullname" v-model="form.fullname" @change="OnAddresschange" maxlength="50"></md-input>
                                </md-field>
                            </b-col>
                            <b-col>
                                <md-field class="forstar">
                                <label>Phone Number</label>
                                <md-input type="number" class="phone" v-model="form.ship_phonenumber" @keydown="removeSpecial($event)"></md-input>
                                </md-field>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <md-field class="forstar">
                                <label>Address</label>
                                <md-input type="text" class="shipaddress" v-model="form.ship_address" @change="OnAddresschange" maxlength="50"></md-input>
                                </md-field>
                            </b-col>
                        </b-row>
                         <b-row>
                            <b-col>
                                <md-field class="forstar">
                                <label>City</label>
                                <md-input type="text" class="shipcity" v-model="form.ship_city" @change="OnAddresschange"></md-input>
                                </md-field>
                            </b-col>
                            <b-col>
                                <div class="md-field md-theme-default forstar">
                                <label class="setuplabel">State</label>
                                <v-select
                                    class="style-chooser shipstate"
                                    :options="shipStates"
                                    v-model="form.ship_state"
                                    :reduce="shipStates => shipStates.code"
                                    label="name"
                                    :clearable="false"
                                    @input="OnAddresschange"
                                    placeholder=""
                                ></v-select>
                                </div>
                            </b-col>
                        </b-row>
                         <b-row>
                            <b-col>
                                <md-field class="forstar">
                                <label>Zip/Postal Code</label>
                                <md-input type="text" class="shippostal" @blur="changeZip" v-model="form.ship_postal"></md-input>
                                </md-field>
                            </b-col>
                            <b-col>
                                <div class="md-field md-theme-default forstar">
                                <label class="setuplabel">Country</label>
                                <v-select
                                    class="style-chooser shipcountry"
                                    :options="shipCountries"
                                    v-model="form.ship_country"
                                    :reduce="shipCountries => shipCountries.code"
                                    label="name"
                                    :clearable="false"
                                    @input="loadShipStates"
                                    placeholder=""
                                ></v-select>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="commres addressfor">
                                    <md-radio v-model="form.addressfor" name="commercial" @change="changeZip" value="commercial">Commercial</md-radio>
                                    <md-radio v-model="form.addressfor" name="residential" @change="changeZip" value="residential">Residential</md-radio>
                                </div>
                            </b-col>
                            <b-col>
                                <!-- <div class="defaultship">
                                    <md-checkbox v-model="form.defaultad" value="1">Make it my default shipping address</md-checkbox>
                                </div> -->
                            </b-col>
                        </b-row>
                        <hr class="lasthr">
                        <b-row class="mobilesetup">
                            <b-col>
                                <a class="backcart" href="javascript:;" @click="stepchange(1)"><b-img class="backarrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img> Return to Information </a>
                            </b-col>
                            <b-col>
                                <b-button type="button" @click="steptwovalidation()" class="float-right" variant="dark">Continue to step 3</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </div>
                <div :class="step3 === true ? 'checkoutsteps step3 show' : 'checkoutsteps step3'">
					<h3 class="mobilehead">Step 3 - Payment</h3>
                    <b-form class="commonform" autocomplete="off"  @submit="onSubmit">
                        <b-row>
                            <b-col>
                                <h3>Payment Method</h3>
                            </b-col>
							<b-col>
							    <ul class="paymenticon">
                                    <li>
                                        <b-img class="payment_method" alt="mastercard" src="/shop/images/mastercard.svg"></b-img>
                                    </li>
                                    <li>
                                        <b-img class="payment_method" alt="discover" src="/shop/images/discover.svg"></b-img>
                                    </li>
                                    <li>
                                        <b-img
                                            class="payment_method"
                                            alt="american express"
                                            src="/shop/images/american-express.svg"
                                        ></b-img>
                                    </li>
                                    <li>
                                        <b-img class="payment_method" alt="visa" src="/shop/images/visa.svg"></b-img>
                                    </li>
							    </ul>
							</b-col>
                        </b-row>
                        <b-row v-if="product_type == 'Hardware'">
                            <b-col>
                                <md-radio v-model="form.pmHWquote" value="orv">Order To Be Reviewed And Verified</md-radio>
                                <md-radio v-model="form.pmHWquote" value="rqe">Receive A Quote Via Email</md-radio>
                            </b-col>
                        </b-row>
                        <div v-if="product_type == 'fauxfur' || (product_type == 'Hardware')">
                            <b-row v-if="form.pmHWquote != 'rqe'">
                                <b-col>
                                    <div class="md-field md-theme-default forstar">
                                    <label class="setuplabel">Payment method</label>
                                    <v-select
                                        class="style-chooser paymethod"
                                        :options="paymethod"
                                        v-model="payment_m_temp"
                                        :reduce="paymethod => paymethod.value"
                                        label="text"
                                        :clearable="false"
                                        placeholder=""
                                    ></v-select>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row v-if="this.payment_m_temp != '6' && form.pmHWquote != 'rqe'">
                                <b-col>
                                    <md-field>
                                        <label>Last 4 Digits Of Credit Card</label>
                                        <md-input type="number" class="card_lastfour" v-model="form.card_lastfour"></md-input>
                                        <p class="error_noti">If credit card is not on file, RM Coco will call for the required information.</p>
                                    </md-field>
                                </b-col>
                            </b-row>
                            <b-row v-if="product_type == 'Hardware'">
                                <b-col>
                                    <md-field>
                                        <p class="error_noti">Effective from September 1, 2019, a 10% tariff surcharge is being applied to all the hardware items.</p>
                                    </md-field>
                                </b-col>
                            </b-row>
                        </div>
                        <div v-else>
                        <b-row>
                            <b-col>
                                <div class="md-field md-theme-default forstar">
                                <label class="setuplabel">Payment method</label>
                                <v-select
                                    class="style-chooser paymethod"
                                    :options="paymethod"
                                    v-model="form.payment_m"
                                    :reduce="paymethod => paymethod.value"
                                    label="text"
                                    :clearable="false"
                                    @input="fieldbilling"
                                    placeholder=""
                                ></v-select>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row v-if="this.form.payment_m != '6'">
                            <b-col>
                                <md-field class="forstar">
                                    <label>Name on card</label>
                                    <md-input type="text" class="nameoncard" v-model="form.nameoncard"></md-input>
                                </md-field>
                            </b-col>
                            <b-col>
                                <md-field class="forstar">
                                    <label>Card Number</label>
                                    <md-input type="number" class="cardnumber" v-model="form.cardnumber" maxlength="16"  @keyup="checkCardLength($event)"></md-input>
                                </md-field>
                            </b-col>
                        </b-row>
                        <b-row v-if="this.form.payment_m != '6'">
                            <b-col md="6" xl="3">
                                <md-field class="forstar">
                                    <label class="setuplabel">Expiration Month</label>
                                    <v-select
										class="style-chooser card_ex_month"
										:options="exmonth"
										v-model="form.card_ex_month"
										label="text"
										:clearable="false"
										placeholder=""
									></v-select>
                                </md-field>
                            </b-col>
							<b-col md="6" xl="3">
                                <md-field class="forstar">
                                    <label class="setuplabel">Expiration Year</label>
                                    <v-select
										class="style-chooser card_ex_year"
										:options="exyear"
										v-model="form.card_ex_year"
                                        :reduce="exyear => exyear.value"
                                        label="text"
										:clearable="false"
										placeholder=""
									></v-select>
                                </md-field>
                            </b-col>
							<b-col md="6" xl="3">
                                <md-field class="forstar">
                                    <label>Security Code</label>
                                    <md-input type="number" class="cvv" v-model="form.cvv" autocomplete="off" maxlength="4" @keyup="checkCardCVVLength($event)"></md-input>
                                </md-field>
                            </b-col>
                            <b-col md="6" xl="3">
                                <a v-b-tooltip.hover id="tooltip-target-1" href="javascript:;" class="what_this">What's this?</a>
                                <b-tooltip target="tooltip-target-1" triggers="hover">
                                    <b>VISA, MasterCard, Discover</b><br>
                                    The last 3-Digits printed on the back of the card.<br>
                                    <b>American Express</b><br>
                                    The 4-Digits security code printed on the front of the card above the 16 digits card number.
                                </b-tooltip>
                            </b-col>
                        </b-row>
                        <hr>
                        <b-row class="setup">
                            <b-col>
                                <h3>Billing Address</h3>
                            </b-col>
                        </b-row>
                        <div class="diffadd">
                            <b-row>
                                <b-col>
                                    <md-field>
                                    <label>Name</label>
                                    <md-input type="text" v-model="form.bill_name" :disabled="isBillFieldDisabled"></md-input>
                                    </md-field>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <md-field>
                                    <label>Address</label>
                                    <md-input type="text" v-model="form.bill_address" :disabled="isBillFieldDisabled" maxlength="50"></md-input>
                                    </md-field>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <md-field>
                                    <label>City</label>
                                    <md-input type="text" v-model="form.bill_city" :disabled="isBillFieldDisabled"></md-input>
                                    </md-field>
                                </b-col>
                                <b-col>
                                    <div class="md-field md-theme-default">
                                    <label class="setuplabel">State</label>
                                    <v-select
                                        class="style-chooser"
                                        :options="billStates"
                                        v-model="form.bill_state"
                                        :reduce="billStates => billStates.code"
                                        label="name"
                                        :clearable="false"
                                        :disabled="isBillFieldDisabled"
                                        placeholder=""
                                    ></v-select>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <md-field>
                                    <label>Zip/Postal Code</label>
                                    <md-input type="text" v-model="form.bill_postal" :disabled="isBillFieldDisabled"></md-input>
                                    </md-field>
                                </b-col>
                                <b-col>
                                    <div class="md-field md-theme-default">
                                    <label class="setuplabel">Country</label>
                                    <v-select
                                        class="style-chooser"
                                        :options="billCountries"
                                        v-model="form.bill_country"
                                        :reduce="billCountries => billCountries.code"
                                        label="name"
                                        :clearable="false"
                                        :disabled="isBillFieldDisabled"
                                        @input="loadBillStates"
                                        placeholder=""
                                    ></v-select>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                        <hr class="lasthr">
                        </div>
                        <b-row class="mobilesetup">
                            <b-col>
                                <a class="backcart" href="javascript:;" @click="steponevalidation()"><b-img class="backarrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img> Return to Shipping </a>
                            </b-col>
                            <b-col>
                                <b-button :disabled="isDisable" type="submit" class="float-right" variant="dark">Place Order</b-button>
                            </b-col>
                            <div class="w-100 text-center mt-4" v-if="show_payment_error">
                                <b-col>
                                    <b-alert show variant="danger">
                                        Correct the billing address and wait for 60 seconds before clicking the place order button again.
                                    </b-alert>
                                </b-col>
                            </div>
                        </b-row>
                    </b-form>
                </div>
            </div>
			<a @click="toggleorder" class="ordershow" href="#">Order Summary<b-img class="plusfil" src="/shop/images/add.svg" alt="add"></b-img><b-img class="minusfil" src="/shop/images/minus.svg" alt="minus"></b-img></a>
            <div class="rightcart">
                <div class="cartproducts">
                    <div class="innerproducts" v-for="(lc,lck) in inCartItems.ITEMS" :key="lck">
                        <div class="prdimg">
                            <b-img :src="lc.SMALL_IMAGE" fluid alt="project image"></b-img>
                        </div>
                        <div class="prdcont">
                            <h3>
                                <span v-if="lc.ORDERTYPE == 'CDI'">{{lc.ITEMNAME}}</span>
                                <span v-else>{{lc.ITEMNAME}} - {{lc.COLORNAME}}</span>
                                <span class="cartprice">${{lc.TOTAL}}</span>
                            </h3>
                            <div class="samediv">
                                <span>ID: </span>
                                <p> {{lc.ITEMID}}-{{lc.INVENTCOLORID}}</p>
                            </div>
                            <div class="samediv">
                                <span>Order Type: </span>
                                <p> {{lc.ORDERTYPE}}</p>
                            </div>
                            <div class="samediv" v-if="lc.BASEFABRICNAME">
                                <span>Base Fabric :</span>
                                <p>{{ lc.BASEFABRICNAME }}</p>
                            </div>
                            <div class="samediv">
                                <span>Price: </span>
                                <p> {{lc.TOTAL}}</p>
                            </div>
                            <div class="samediv">
                                <span>Qty: </span>
                                <p> {{lc.QTY}}</p>
                            </div>
                            <div class="samediv" v-if="lc.STATUS == 'Discontinued' && Number(lc.QTY) > Number(lc.MAXQTY)">
                                <p class="notify_exceed">Seleted quantity is not availabile.</p>
                            </div>
                        </div>
                    </div>
                </div>
                 <div class="rightinner">
                      <div class="cartvalue">
                          <span>Sub Total</span>
                          <p>${{inCartItems.subtotal}}</p>
                      </div>
                      <div class="cartvalue">
                          <span>Shipping</span>
                          <p><span v-if="inCartItems.shipping != 'TBD'">$</span>{{inCartItems.shipping}}</p>
                      </div>
                      <div class="cartvalue" v-if="inCartItems.tariff > 0">
                          <span>Tariff</span>
                          <p>${{inCartItems.tariff}}</p>
                      </div>
                      <div class="cartvalue totalvalue">
                          <span>Total</span>
                          <p>${{inCartItems.total}}</p>
                      </div>
                      <div class="help_signup">
                          <p>Need Help with this order?</p>
                          <b-button @click="callusTrigger" variant="outline-primary" squared v-html="callustext"></b-button>
                          <b-button @click="emailusTrigger" variant="outline-primary" squared><b-img src="/shop/images/mail.svg" class="mailblack"></b-img><b-img src="/shop/images/mail-white.svg" class="mailwhite"></b-img>Email Us</b-button>
                      </div>
                  </div>
            </div>
        </div>
        <footer>
            <div class="container">
                <div class="footlink">
                    <ul>
                        <li><a href="/terms-of-services/">Terms of Sevices</a></li>
                        <li><a href="/privacy-policy/">Privacy Policy</a></li>
                    </ul>
                    <p class="copyright_text">© 1980 - {{ new Date().getFullYear() }} RM COCO</p>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { ModelSelect } from 'vue-search-select';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
    components:{
        ModelSelect,
        'v-select': vSelect,
        Loading
    },
    computed: {
        ...mapGetters(["user","cartproducts"]),
        inCartItems(){
            return this.cartproducts;
        }
    },
    mounted(){
        this.loadCartItems(this.user.accountnumber);
        this.loadShipCountries();
        this.loadShipStates("USA");
        this.loadBillCountries();
        this.loadBillStates("USA");

		this.$store.dispatch("loadSaveAddress").then(saveaddress => {
			this.savedadd = saveaddress.data;
		});
		this.$store.dispatch("loadCheckoutinfo",this.user.accountnumber).then(loadCheckoutinfo => {
			// this.form.email=loadCheckoutinfo.data.email;
			this.form.fullname=loadCheckoutinfo.data.ship_name;
            this.form.ship_phonenumber=loadCheckoutinfo.data.ship_phone;
            this.form.ship_address=loadCheckoutinfo.data.ship_street;
			this.form.ship_city=loadCheckoutinfo.data.ship_city;
            this.form.ship_state=loadCheckoutinfo.data.ship_state;
			this.form.ship_postal=loadCheckoutinfo.data.ship_zipcode;
            this.form.ship_country=loadCheckoutinfo.data.ship_country;
            this.form.bill_name=loadCheckoutinfo.data.bill_name;
            this.form.bill_address=loadCheckoutinfo.data.bill_street;
			this.form.bill_city=loadCheckoutinfo.data.bill_city;
            this.form.bill_state=loadCheckoutinfo.data.bill_state;
			this.form.bill_postal=loadCheckoutinfo.data.bill_zipcode;
            this.form.bill_country=loadCheckoutinfo.data.bill_country;
            this.form.customertype = loadCheckoutinfo.data.DLVTERMID;
			this.exmonth = loadCheckoutinfo.data.ex_month;
            this.exyear = loadCheckoutinfo.data.ex_year;
            this.payment_term = loadCheckoutinfo.data.PAYMTERMID;

            if(this.payment_term != null && this.payment_term[0] === "N"){
               if(this.product_type == 'fauxfur' || (this.product_type == 'Hardware')){
                   this.payment_m_temp = "6";
               } else{
                   this.form.payment_m = "6";
               }
            }

            if(this.payment_term != null && this.payment_term == "CC"){
                if(this.cartproducts.hasOwnProperty('ITEMS') && this.cartproducts.ITEMS.length > 0 && this.cartproducts.ITEMS[0].ORDERTYPE == "regular"){
                    if(parseFloat(this.cartproducts.total) > 0){
                        this.paymethod = this.paymethod.filter(payment => {
                            return payment.value != "6";
                        });
                    } else{
                        this.paymethod = this.paymethod.filter(payment => {
                            return payment.value == "6";
                        });
                    }
                }
            }
        });

        this.form.orderby = this.user.firstname+' '+this.user.lastname;
        this.form.email = this.user.email;
    },
    data(){
        return{
			errors: [],
            shipCountries:[],
            shipStates:[],
			getaddress:[],
            billCountries:[],
            billStates:[],
			getshipping:{},
			exmonth:[],
			exyear:[],
            form: {
                orderby: null,
                email: null,
                poside:null,
                savedaddress:null,
                fullname : null,
                ship_phonenumber : null,
                ship_address : null,
                ship_city : null,
                ship_state : null,
                ship_postal : null,
                ship_country : "USA",
                bill_name : null,
                bill_address : null,
                bill_city : null,
                bill_state : null,
                bill_postal : null,
                bill_country : "USA",
                addressfor : "commercial",
                defaultad : null,
                shipmethod : "",
                specialinfo : null,
                payment_m: null,
                nameoncard:null,
                card_ex_month:null,
                card_ex_year:null,
                cardnumber:null,
                cvv:null,
                card_lastfour:null,
                ship_amount : null,
                total_amount : null,
                oneflat: "",
                pmHWquote : "orv",
                customertype:"",
                isCDI : false
            },
            step1:true,
            step2:false,
            step3:false,
            savedadd: [],
            shipmethod: [
                { value: 'none_-3', text: 'Pickup'},
                { value: 'FED', text: 'Ground'},
                { value: 'FED2DA', text: '2nd Day Air'},
                { value: 'FEDNDA', text: 'Next Day Air'},
            ],
            shipdisabled:false,
            method: '',
            paymethod: [
                { value: '2', text: 'American Express'},
                { value: '3', text: 'Mastercard'},
                { value: '4', text: 'Visa'},
                { value: '5', text: 'Discover Card'},
                { value: '6', text: 'Accounts Receivable'},
            ],
            payment: '',
            isLoading: false,
            isLoadingSubmit: false,
            radio:"ship",
            billShow:false,
            isBillFieldDisabled: false,
            shipping_error:null,
            payment_m_temp:null,
            product_type:null,
            isDisable:false,
            oldCardnumber:'',
            oldCardCvvnumber:'',
            callustext: '<img src="/shop/images/phone.svg" class=""><img src="/shop/images/phone-white.svg" class="whitephone"> Call Us',
            payment_term: null,
            show_payment_error: false,
            isOneFlatEnable: false
        }
    },
    methods:{
		toggleorder(){
            $(".rightcart").toggle();
             $(".ordershow").toggleClass("minusshow");
		},
        OnAddresschange(){
            this.form.savedaddress = "";
            this.changeZip();
        },
        removeSpecial(e){
            if (/^\W$/.test(e.key)) {
                e.preventDefault();
            }
        },
        steponevalidation(){
			let error = '';
            let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/;
            if(!this.form.orderby){
                $(".orderby").addClass("shiperror");
                error += "1";
            }else{
                $(".orderby").removeClass("shiperror");
            }
            if(!this.form.email){
                $(".email").addClass("shiperror");
                error += "1";
            }else if (reg.test(this.form.email) === false){
                $(".email").addClass("shiperror");
                error += "1";
            }else{
                $(".email").removeClass("shiperror");
            }
			if(error == ''){
				this.stepchange(2);
                return true;
            }else{
                this.$notify({
                    text:"There is a validation error. Please correct the fields outlined in red and try again.",
                    type: "error"
                });
                return false;
            }
        },

        steptwovalidation(){
            let error = '';
            if (!this.form.shipmethod && !this.form.oneflat) {
                $(".shipmethod .vs__dropdown-toggle").css("border-color","#f00");
                error += "1";
            }else{
                $(".shipmethod .vs__dropdown-toggle").removeAttr("style");
            }
            if(this.getshipping.error === true){
                $(".shipmethod .vs__dropdown-toggle").css("border-color","#f00");
                error += "1";
            }else{
                $(".shipmethod .vs__dropdown-toggle").removeAttr("style");
            }
            if (!this.form.fullname) {
                $(".fullname").addClass("shiperror");
                error += "1";
            }else{
                $(".fullname").removeClass("shiperror");
            }
            if (!this.form.ship_phonenumber) {
                $(".phone").addClass("shiperror");
                error += "1";
            }else{
                $(".phone").removeClass("shiperror");
            }
            if (!this.form.ship_address) {
                $(".shipaddress").addClass("shiperror");
                error += "1";
            }else if(this.form.ship_address.length > 50){
                $(".shipaddress").addClass("shiperror");
                error += "1";
            }else{
                $(".shipaddress").removeClass("shiperror");
            }

            if (!this.form.ship_city) {
                $(".shipcity").addClass("shiperror");
                error += "1";
            }else{
                $(".shipcity").removeClass("shiperror");
            }

            if (!this.form.ship_state) {
                $(".shipstate .vs__dropdown-toggle").css("border-color","#f00");
                error += "1";
            }else{
                $(".shipstate .vs__dropdown-toggle").removeAttr("style");
            }

            if (!this.form.ship_country) {
                $(".shipcountry").parents(".vs__dropdown-toggle").css("border-color","#f00");
                error += "1";
            }else{
                $(".shipcountry").parents(".vs__dropdown-toggle").removeAttr("style");
            }

            if (!this.form.ship_postal) {
                $(".shippostal").addClass("shiperror");
                error += "1";
            }else{
                $(".shippostal").removeClass("shiperror");
            }

            if (!this.form.addressfor) {
                $(".addressfor").addClass("shiperror");
                error += "1";
            }else{
                $(".addressfor").removeClass("shiperror");
            }
            if(error == ''){
				this.stepchange(3);
                if(this.payment_term != null && this.payment_term == "CC"){
					if(this.cartproducts.hasOwnProperty('ITEMS') && this.cartproducts.ITEMS.length > 0 && this.cartproducts.ITEMS[0].ORDERTYPE == "memo"){
						if(this.form.oneflat && parseFloat(this.cartproducts.total) > 0){
							this.paymethod = [{ value: '2', text: 'American Express'},{ value: '3', text: 'Mastercard'},{ value: '4', text: 'Visa'},{ value: '5', text: 'Discover Card'}];
							this.form.payment_m = "4";
						} else{
							this.paymethod = [{ value: '6', text: 'Accounts Receivable'}];
							this.form.payment_m = "6";
						}
					}
				}
                return true;
            }else{
                this.$notify({
                    text:"There is a validation error. Please correct the fields outlined in red and try again.",
                    type: "error"
                });
                return false;
            }
        },

        stepthreevalidation(){
            let error = '';
            if (!this.form.payment_m) {
                $(".paymethod .vs__dropdown-toggle").css("border-color","#f00");
                error += "1";
            }else{
                $(".paymethod .vs__dropdown-toggle").removeAttr("style");
            }

            if(this.form.payment_m != "6"){
                if (!this.form.nameoncard) {
                    $(".nameoncard").addClass("shiperror");
                    error += "1";
                }else{
                    $(".nameoncard").removeClass("shiperror");
                }
                if (!this.form.cardnumber) {
                    $(".cardnumber").addClass("shiperror");
                    error += "1";
                }else{
                    $(".cardnumber").removeClass("shiperror");
                }
                if (!this.form.cvv) {
                    $(".cvv").addClass("shiperror");
                    error += "1";
                }else{
                    $(".cvv").removeClass("shiperror");
                }
                if (!this.form.card_ex_month) {
                    $(".card_ex_month .vs__dropdown-toggle").css("border-color","#f00");
                    error += "1";
                }else{
                    $(".card_ex_month .vs__dropdown-toggle").removeAttr("style");
                }
                if (!this.form.card_ex_year) {
                    $(".card_ex_year .vs__dropdown-toggle").css("border-color","#f00");
                    error += "1";
                }else{
                    $(".card_ex_year .vs__dropdown-toggle").removeAttr("style");
                }
            }
            if(this.product_type == 'Hardware' || this.product_type == 'fauxfur'){
                if(this.form.pmHWquote != 'rqe'){
                    if (!this.payment_m_temp) {
                        $(".paymethod .vs__dropdown-toggle").css("border-color","#f00");
                        error += "1";
                    }else{
                        $(".paymethod .vs__dropdown-toggle").removeAttr("style");
                    }
                    if (this.payment_m_temp != '6') {
                        if (!this.form.card_lastfour) {
                            $(".card_lastfour").addClass("shiperror");
                            error += "1";
                        }else{
                            $(".card_lastfour").removeClass("shiperror");
                        }
                    }
                }
            }else{
                this.form.pmHWquote = "";
            }

            if(error == ''){
                return true;
            }else{
                this.$notify({
                    text:"There is a validation error. Please correct the fields outlined in red and try again.",
                    type: "error"
                });
                return false;
            }
        },
        stepchange(step){
            event.preventDefault();
            this.step1 = false;
            this.step2 = false;
            this.step3 = false;
            if(step == 1){
                this.step1 = true;
            }
            if(step == 2){
				this.step2 = true;
            }
            if(step == 3){
				this.step3 = true;
                this.fieldbilling();
            }
            return false;
        },
        fieldbilling(){
            if(this.form.payment_m == '6'){
                this.isBillFieldDisabled = true;
            }else{
                this.isBillFieldDisabled = false;
            }
        },
        loadCartItems(user_id){
            this.$store.dispatch("loadCart",user_id).then(cartdata => {
                this.isLoading = false;
                if(cartdata.data.ITEMS.length > 0){
                    this.product_type = cartdata.data.ITEMS[0].PC_TYPE;
                    if(cartdata.data.ITEMS[0].PC_TYPE == 'fauxfur'){
                        this.shipping_error = 'Shipping charges will be added at time of delivery.';
                    }
                    if(cartdata.data.ITEMS[0].PC_TYPE == 'CDI' || cartdata.data.ITEMS[0].PC_TYPE == 'CDIP' || cartdata.data.ITEMS[0].PC_TYPE == 'CDIQ'){
                        this.shipping_error = 'Shipping charges will be added at time of delivery.';
                        this.paymethod = [{ value: '6', text: 'Accounts Receivable'}];
                        this.form.payment_m = "6";
                        this.form.isCDI = true;
                    }
                    if(cartdata.data.ITEMS[0].PC_TYPE == 'Sample'){
                        this.shipmethod = [{ value: 'FED', text: 'Least Cost'}];
                        this.shipping_error = 'For expedited shipping, please call customer service at 1-800-325-8025.';
                        if(cartdata.data.subtotal == 0){
                            this.paymethod = [{ value: '6', text: 'Accounts Receivable'}];
                            this.form.payment_m = "6";
                        }
                    }
                    this.order_type = cartdata.data.ITEMS[0].ORDERTYPE;
                    if(this.order_type == 'memo'){
                        this.shipmethod = [{ value: 'none_-2', text: 'USPS'}];
                        // this.paymethod = [{ value: '6', text: 'Accounts Receivable'}];
                        // this.form.payment_m = "6";
                    }
                    if(this.order_type == 'cutforapproval' || this.order_type == 'holdtendays'){
                        this.paymethod = [{ value: '6', text: 'Accounts Receivable'}];
                        this.form.payment_m = "6";
                    }
                    if(cartdata.data.alldropship == true && cartdata.data.totalqtyFlat <= 3){
                        this.isOneFlatEnable = true;
                    }else{
                        if(this.order_type == 'memo'){
                            this.isOneFlatEnable = true;
                        }
                    }
                    this.inCartItems.ITEMS.filter(lc => {
                        if(lc.STATUS == "Discontinued" && lc.QTY > lc.MAXQTY){
                            this.$router.push({ name: "cart" });
                        }
                    });
                }else{
                    this.$router.push({ name: "cart" });
                }
            }).catch(() => {
                this.loadCartItems(this.user.accountnumber);
            });
        },
        loadShipCountries(){
            this.$store.dispatch("loadCountries").then(shipCountries => {
                this.shipCountries = shipCountries.data;
            });
        },
        loadShipStates(countryid){
			this.form.ship_state = null;
            this.$store.dispatch("loadStates",countryid).then(shipStates => {
                this.shipStates = shipStates.data;
            });
        },
        loadBillCountries(){
            this.$store.dispatch("loadCountries").then(billCountries => {
                this.billCountries = billCountries.data;
            });
        },
        loadBillStates(countryid){
			this.form.bill_state = null;
            this.$store.dispatch("loadStates",countryid).then(billStates => {
                this.billStates = billStates.data;
            });
        },
        getShipping(shipmethod){
            if(this.cartproducts.ITEMS[0].PC_TYPE == 'fauxfur' || this.cartproducts.ITEMS[0].PC_TYPE == 'Hardware' || this.cartproducts.ITEMS[0].PC_TYPE == 'CDI' || this.cartproducts.ITEMS[0].PC_TYPE == 'CDIP' || this.cartproducts.ITEMS[0].PC_TYPE == 'CDIQ'){
                if(shipmethod != 'none_-3'){
                    this.shipping_error = 'Shipping charges will be added at time of delivery.';
                }else{
                    this.shipping_error = null;
                }
            }else if(this.cartproducts.ITEMS[0].ORDERTYPE == 'holdtendays'){
                this.shipping_error = null;
            }else{
                if(this.form.customertype == '3D'){
                    this.shipping_error = null;
                }else{
                    if(this.cartproducts.ITEMS[0].ORDERTYPE == 'memo'){
                        this.shipping_error = "Memos are shipped USPS. For expedited shipping please specify preferred shipping method in special instructions below."
                    }else{
                        this.shipping_error = null;
                    }
                    this.isLoading = true;
                    let ship_A = this.form.ship_address.replace(/[^a-zA-Z0-9 ]/g, "");
                    this.$store.dispatch("loadShipping",{
                        shipping_method: shipmethod,
                        total: this.inCartItems.total,
                        oneflat: this.form.oneflat,
                        ship_address: ship_A,
                        ship_city: this.form.ship_city,
                        ship_state: this.form.ship_state,
                        ship_country: this.form.ship_country,
                        ship_postal: this.form.ship_postal,
                        isresidential : this.form.addressfor=="residential"?true:false
                    }).then(getshipping => {
                        this.getshipping = getshipping.data;
                        this.loadCartItems(this.user.accountnumber);
                        if(this.getshipping.error === true){
                            this.shipping_error = this.getshipping.errorMsg;
                        }
                        if(getshipping.data.pkgWeight > 150){
                            this.shipping_error = 'Order exceeds 150 lbs. Shipping charges will be added at time of delivery.';
                        }
                    });
                }
            }
        },
        getShippingOneFlat(){
            if(this.form.oneflat == "1"){
                this.shipdisabled = true;
                this.getShipping(this.form.shipmethod);
            }else{
                this.shipdisabled = false;
                this.form.shipmethod = "none_-3";
                if(this.cartproducts.ITEMS[0].ORDERTYPE == 'memo'){
                    this.form.shipmethod = "none_-2";
                }
                this.getShipping(this.form.shipmethod);
            }
        },
		getAddress(addressid){
            let tempAddress = this.savedadd;
            if (addressid != '' && addressid) {
                tempAddress = tempAddress.filter((item) => {
                    return item.ADDRESSID == addressid;
                });
                if(tempAddress[0].LOCATIONNAME){
                    this.form.fullname = tempAddress[0].LOCATIONNAME;
                }else{
                    this.form.fullname = tempAddress[0].NAME;
                }
                this.form.ship_address=tempAddress[0].STREET;
                this.form.ship_city=tempAddress[0].CITY;
                this.loadShipStates(tempAddress[0].COUNTRYREGIONID);
                this.form.ship_state=tempAddress[0].STATE;
                this.form.ship_country=tempAddress[0].COUNTRYREGIONID;
                this.form.ship_postal=tempAddress[0].ZIPCODE;
                if (!this.form.shipmethod) {
                    this.shipping_error = 'Select Shipping Method.';
                    return;
                }else{
                    $(".shipmethod .vs__dropdown-toggle").removeAttr("style");
                }
                this.getShipping(this.form.shipmethod);
            }else{
				this.form.fullname=null;
				this.form.ship_phonenumber=null;
				this.form.ship_address=null;
				this.form.ship_city=null;
				this.form.ship_state=null;
				this.form.ship_country=null;
				this.form.ship_postal=null;
				this.form.addressfor=null;
				this.form.defaultad=null;

			}
		},
		onSubmit(evt) {
            evt.preventDefault();
            if(this.cartproducts.ITEMS[0].PC_TYPE == 'fauxfur' || this.cartproducts.ITEMS[0].PC_TYPE == 'Hardware'){
                this.form.payment_m = "6";
            }
            if(this.stepthreevalidation()){
                this.isDisable = true;
                this.isLoadingSubmit = true;
                this.form.ship_amount = this.cartproducts.shipping;
                this.form.total_amount = this.cartproducts.total;
                // if(this.radio == 'ship'){
                //     this.sameAddressTrigger(this.radio);
                // }
                this.$store.dispatch("placeOrder", {
                    user_id:this.user.accountnumber,
                    is_online: this.user.is_online,
                    form: this.form
                })
                .then(data => {
					if(data.success.success === true){
                        this.isLoadingSubmit = false;
						this.$notify({
							text: "Thank you, your order placed successfully",
							type: "success"
						});
						if(data.success.mail === false){
                            this.$router.push({path:"/shop/thankyou/"+data.success.SALESORDER,query:{mailmsg:"0"}});
                        }else{
                            this.$router.push("/shop/thankyou/"+data.success.SALESORDER);
                        }
					}else{
						this.$notify({
							text: data.success.SALESORDER,
							type: "error",
                            duration: 20000
                        });
                        this.isDisable = false;
                        this.isLoadingSubmit = false;

                        if(data.success.hasOwnProperty('payment_failure') && data.success.payment_failure === true){
                            this.show_payment_error = true;
                            this.isDisable = true;
                            var self = this;
                            setTimeout(function() {
                                self.show_payment_error = false;
                                self.isDisable = false;
                            }, 60000);
                        }
					}
                })
                .catch(error => {
                    if (this.form.hasErrors()) {
                        this.$notify({
                            text:
                            "There is a validation error. Please correct the fields outlined in red and try again.",
                            type: "error"
                        });
                    } else {
                        this.$notify({
                            text: "Something went wrong! Try again.",
                            type: "error"
                        });
                    }
                    this.isDisable = false;
                    this.isLoadingSubmit = false;
                });
            }else{
                console.log("Validation error on payment method");
            }
        },
        callusTrigger(){
            this.callustext = "800 325 8025";
        },
        emailusTrigger(){
            window.location.href = "mailto:customerservice@rmcoco.com";
        },
        sameAddressTrigger(val){
            if(val == 'ship'){
                this.form.bill_address = this.form.ship_address;
                this.form.bill_city = this.form.ship_city;
                this.form.bill_state = this.form.ship_state;
                this.form.bill_country = this.form.ship_country;
                this.form.bill_postal = this.form.ship_postal;
            }else{
                this.form.bill_address = "";
                this.form.bill_city = "";
                this.form.bill_state = "";
                this.form.bill_country = "";
                this.form.bill_postal = "";
            }
        },
        checkCardLength(e){
            if(e.keyCode == 189){
                this.form.cardnumber=this.oldCardnumber;
                return;
            }

            if (this.form.cardnumber.length > 16)
            {
                const val = this.form.cardnumber.slice(0,16);
                this.form.cardnumber = val;
                this.oldCardnumber=val;
            }else {
                this.oldCardnumber=e.target.value;
                this.form.cardnumber = e.target.value;
            }
        },
        checkCardCVVLength(e){
            if(e.keyCode == 189){
                this.form.cvv=this.oldCardCvvnumber;
                return;
            }
            if (this.form.cvv.length > 4){
                const val = this.form.cvv.slice(0,4);
                this.form.cvv = val;
                this.oldCardCvvnumber=val;
            }else {
                this.oldCardCvvnumber=e.target.value;
                this.form.cvv = e.target.value;
            }
        },
        changeZip(){
            this.form.savedaddress = "";
            if (!this.form.shipmethod) {
                this.shipping_error = 'Select Shipping Method.';
                return;
            }else{
                $(".shipmethod .vs__dropdown-toggle").removeAttr("style");
            }
            this.getShipping(this.form.shipmethod);
        }
    }
}
</script>

<style>
.checkoutpage header,.checkoutpage footer{
    height:75px;
    box-shadow: 1px 1px 12px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 1px 1px 12px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 1px 1px 12px rgba(0, 0, 0, 0.2);
    position: relative;
    width: 100%;
    background: #fff;
    z-index: 10;
}
.checkoutpage .error_noti{
    font-size: 12px;
}
.checkoutpage header .carthead{
    display: flex;
    justify-content: space-between;
    margin: 0;
    width: 100%;
    flex-wrap: nowrap;
    align-items: center;
    height: 75px;
}
.checkoutpage header .carthead .cartlogosec img{
    width: 190px;
    height: 60px;
}
.checkoutpage header .cartsteps{
    max-width: 510px;
    width: 100%;
}
.checkoutpage header .cartsteps ul li{
    float: left;
}
.checkoutpage header .cartsteps ul li a.backcart{
    font-size: 16px;
    color:#777777;
    font-weight:normal;
    margin-right: 5px;
    text-decoration: none;
}
.checkoutpage .ordershow{
	display:none;
}
.checkoutpage header .cartsteps ul li a.backcart.active{
    font-weight: 600;
    color: #303030;
}
.checkoutpage header .cartsteps ul li a.backcart:hover{
    border-bottom: 0;
}
.checkoutpage header .cartsteps ul li a.backcart .backarrow{
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg);
    margin: 0 0 0 3px;
}
.checkoutpage .backcart{
    font-size: 14px;
    color: #303030;
    font-weight: 600;
    border-bottom: 1px solid #ffffff;
    padding-bottom: 3px;
}
.checkoutpage .backcart:hover{
    text-decoration: none;
    border-bottom: 1px solid #303030;
}
.checkoutpage .backarrow{
    height: 12px;
    width: 12px;
    transform: rotate(90deg);
    margin-top: -2px;
}
.page--checkout .maincart .leftcart{min-height: calc(100vh - 150px);}
.checkoutpage .maincart .leftcart .checkoutsteps{
    padding: 40px 80px 80px 0;
    display: none;
}
.checkoutpage .maincart .leftcart .checkoutsteps.show{display:block}
.checkoutpage .maincart .leftcart .checkoutsteps h3.mobilehead{
	display:none;
}
.checkoutpage .maincart .leftcart .checkoutsteps .diffadd{
    margin-top: 15px;
}
.checkoutpage .maincart .leftcart .checkoutsteps.step2,.checkoutpage .maincart .leftcart .checkoutsteps.step3{
    min-height: 84vh;
}
.checkoutpage .maincart .leftcart .checkoutsteps .backcart{
    display: inline-block;
    margin-top: 20px;
}
.checkoutpage .maincart .leftcart .checkoutsteps.step2 input[type="textarea"]{
    height: 140px;
    margin-bottom: 70px;
}
.checkoutpage .maincart .leftcart .checkoutsteps .md-field.md-has-password{
    margin-bottom: 50px;
}
.checkoutpage .maincart .leftcart .checkoutsteps.step3 .what_this{
    font-size: 12px;
    color: #777777;
    display: inline-block;
    margin-top:35px;
}
.checkoutpage .maincart .leftcart .checkoutsteps.step3 .what_this:hover{
    text-decoration: none;
}
.checkoutpage .maincart .leftcart .checkoutsteps h3{
    text-align: left;
}
.checkoutpage .maincart .leftcart .checkoutsteps .vs__search{
    padding-left: 20px;
}
.checkoutpage .maincart .leftcart .checkoutsteps .vs__selected{
    padding-left:17px;
}
.checkoutpage .maincart .leftcart hr{
    margin-bottom: 40px;
    border-top: 1px solid #d2d2d2;
    margin-top: 28px;
}
.checkoutpage .maincart .leftcart hr.lasthr {
    margin-bottom: 80px;
}
.checkoutpage .maincart .leftcart .checkoutsteps .md-field{
    margin-bottom: 15px;
}
.checkoutpage .maincart .leftcart .checkoutsteps .row.setup {
    margin-bottom: 10px;
}
.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown{
    margin-bottom: 15px;
    padding-top: 13px;
    padding-bottom: 13px;
    margin-top: 20px;
    border: 1px solid #d2d2d2;
}
.checkoutpage .maincart .leftcart .checkoutsteps .ui.search.dropdown>.text.default {
    position: relative;
    top: -20px;
    background: #fff;
    padding: 0 3px;
}
.checkoutpage .maincart .leftcart .checkoutsteps .ui.search.dropdown>.text{
    color: #303030 !important;
    font-size: 12px;
}
.checkoutpage .maincart .leftcart .checkoutsteps .ui.search.dropdown>input.search,.checkoutpage .maincart .leftcart .checkoutsteps .ui.search.dropdown>input.search{
    font-weight: 600;
    color: #303030 !important;
}
.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown .menu>.item.selected,.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown .menu>.item.selected{
    font-weight: 600;
}
.checkoutpage .maincart .leftcart .checkoutsteps .ui.search.selection.dropdown>input.search,.checkoutpage .maincart .leftcart .checkoutsteps .ui.search.selection.dropdown>input.search{
    padding-right: 15px;
    padding-left: 15px;
}
.checkoutpage .maincart .leftcart .checkoutsteps .ui.search.dropdown>.text{
    color: #303030;
    font-weight: 600;
}
.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown::after,.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown::after{
    content: "";
    background: url(/shop/images/arrow.svg) no-repeat center;
    height: 10px;
    width:10px;
    position: absolute;
    right: 12px;
    top:15px;
    margin: 0;
}
.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown.active::after,.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown.active::after{
    transform: rotate(180deg);
}
.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown:hover,.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown:hover{
    border:1px solid #d2d2d2;
    border-radius: 3px;
}
.checkoutpage .maincart .leftcart .checkoutsteps .ui.fluid.dropdown>.dropdown.icon,.checkoutpage .maincart .leftcart .checkoutsteps .ui.fluid.dropdown>.dropdown.icon{
    display:none;
}
.checkoutpage .maincart .leftcart .checkoutsteps .ui.search.dropdown>input.search,.checkoutpage .maincart .leftcart .checkoutsteps .ui.search.dropdown>input.search,.checkoutpage .maincart .leftcart .checkoutsteps .ui.search.dropdown>.text{
    color: #303030 !important;
    font-size: 12px;
    font-weight: normal;
    top:2px;
}
.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.active.dropdown:hover,.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.active.dropdown:hover .menu,.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.active.dropdown:hover,.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.active.dropdown:hover .menu{
    border-color: #d2d2d2;
    box-shadow: none;
}
.checkoutpage .maincart .leftcart .checkoutsteps .ui.search.selection.dropdown>input.search,.checkoutpage .maincart .leftcart .checkoutsteps .ui.search.selection.dropdown>span.sizer,.checkoutpage .maincart .leftcart .checkoutsteps .ui.search.selection.dropdown>input.search,.checkoutpage .maincart .leftcart .checkoutsteps .ui.search.selection.dropdown>span.sizer{
    line-height: 1.8em;
}
.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown .menu,.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown .menu{
    top: -155px;
    border-radius: 0 !important;
    border: 1px solid #d2d2d2;
    border-top: 1px solid #d2d2d2 !important;
    padding: 10px 0;
}
.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown .menu{
    top: 40px;
}
.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown .menu>.item,.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown .menu>.item{
    font-size: 12px;
    line-height: 20px;
    color: #303030;
    padding:0;
    border:0;
}
.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown .menu,.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown .menu>.item,.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown .menu,.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown .menu>.item{
    font-size: 12px;
    line-height: 16px;
    color: #303030;
}
.checkoutpage .maincart .leftcart .checkoutsteps .ui.fluid.dropdown>.dropdown.icon,.checkoutpage .maincart .leftcart .checkoutsteps .ui.fluid.dropdown>.dropdown.icon{
    display: none;
}
.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown .menu>.item:hover,.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown .menu>.item.selected,.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown .menu>.item:hover,.checkoutpage .maincart .leftcart .checkoutsteps .ui.selection.dropdown .menu>.item.selected{
    background: transparent;
}
.common_pop .ui.search.dropdown>.text.default{
    position: relative;
    top: -20px;
    background: #fff;
    padding: 0 3px;
}
.checkoutpage .maincart .leftcart .defaultship {
    width: 100%;
    text-align: right;
    margin-top:20px
}
.checkoutpage .maincart .leftcart .defaultship .md-checkbox-label{
    font-size:12px;
    color:#303030;
}
.checkoutpage .maincart .leftcart .commres{
    margin-top: 20px;
}
.checkoutpage .maincart .leftcart .btn.float-right.btn-dark{
    width: 250px;
}
.checkoutpage .maincart .rightcart{
    padding-top: 15px;
}
.checkoutpage .maincart .rightcart .rightinner{
    padding-top: 30px;
}
.checkoutpage .maincart .rightcart .rightinner .help_signup img{
    height: 14px;
    width: 14px;
    margin-top: -2px;
    margin-right: 5px;
}
.checkoutpage .maincart .rightcart .rightinner .help_signup img.whitephone{
	display:none;
}
.checkoutpage .maincart .rightcart .rightinner .help_signup img.mailwhite{
    display: none;
}
.checkoutpage  .maincart .rightcart .rightinner .help_signup{
    display: block;
    text-align: center;
    margin-top: 80px;
}
.checkoutpage .maincart .rightcart .rightinner .help_signup p{
    margin-bottom: 20px;
}
.checkoutpage .maincart .rightcart .rightinner .help_signup .btn.btn-outline-primary{
    width: 150px;
    margin-right: 20px;
}
.checkoutpage .maincart .rightcart .rightinner .help_signup .btn.btn-outline-primary:last-child{
    margin-right: 0;
}
.checkoutpage .maincart .rightcart .rightinner .help_signup .btn.btn-outline-primary:hover .mailblack,
.checkoutpage .maincart .rightcart .rightinner .help_signup .btn.btn-outline-primary:hover img{
    display: none;
}
.checkoutpage .maincart .rightcart .rightinner .help_signup .btn.btn-outline-primary:hover .mailwhite,
.checkoutpage .maincart .rightcart .rightinner .help_signup .btn.btn-outline-primary:hover img.whitephone{
    display: inline-block;
}
.checkoutpage .maincart .rightcart .cartproducts{
    width:380px;
}
.checkoutpage .maincart .rightcart .cartproducts .innerproducts{
    display: flex;
    justify-content: left;
    flex-wrap: nowrap;
    width:100%;
    padding: 40px 0;
    box-sizing:border-box;
    border-bottom: 1px solid #d2d2d2;
}
.checkoutpage .maincart .rightcart .cartproducts .innerproducts .prdimg{
    height: 72px;
    width: 72px;
    border-radius: 3px;
    overflow: hidden;
    margin-right: 10px;
}
.checkoutpage .maincart .rightcart .cartproducts .innerproducts .prdimg img{
    width:100%;
}
.checkoutpage .maincart .rightcart .cartproducts .innerproducts .prdcont{
    flex-grow: 1;
}
.checkoutpage .maincart .rightcart .cartproducts .innerproducts .prdcont h3{
    margin: 0 0 5px 0;
    width: 100%;
    text-align: left;
}
.checkoutpage .maincart .rightcart .cartproducts .innerproducts .prdcont h3 span{
	width:75%;
	display:inline-block;
}
.checkoutpage .maincart .rightcart .cartproducts .innerproducts .prdcont h3 span.cartprice{
    float:right;
	width:auto;
}
.checkoutpage .maincart .rightcart .cartproducts .innerproducts .prdcont .samediv{
    width:68%;
}
.checkoutpage .maincart .rightcart .cartproducts .innerproducts .prdcont .samediv span,.checkoutpage .maincart .rightcart .cartproducts .innerproducts .prdcont .samediv p{
    font-size: 14px;
    color:#777777;
    float:left;
}
.checkoutpage .maincart .rightcart .cartproducts .innerproducts .prdcont .samediv p{
    color:#303030;
    margin-left:5px;
    float: none;
}
.checkoutpage .maincart .rightcart .cartproducts .innerproducts .prdcont .samediv .notify_exceed{
    font-size: 10px;
    font-weight: normal;
    color: #ff0101;
    text-align: left;
    margin-left:0;
}
.checkoutpage .vs--searchable .vs__dropdown-toggle,.vs--unsearchable .vs__dropdown-toggle{height:43px}
.checkoutpage footer{
    padding: 0;
}
.checkoutpage footer .footlink{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 75px;
}
.checkoutpage footer .footlink ul li{
    float:left;
}
.checkoutpage footer .footlink ul li a{
    display: inline-block;
    color: #303030;
    font-size: 14px;
    line-height: 24px;
    font-weight: 600;
    text-decoration: none;
    margin-right: 20px;
}
.checkoutpage footer .footlink ul li a:hover{
    text-decoration: none;
    text-shadow: 0px 0px 1px #303030;
}
.checkoutpage footer .footlink .copyright_text{
    font-weight: 600;
    color: #303030;
    font-size: 14px;
}
.commonform .md-field .md-input.shiperror, .commonform .md-field .md-textarea.shiperror, .style-chooser.shiperror .vs__selected-options input{
	border: 1px solid #ff0000;
}
.commonform .md-field .md-input[disabled], .commonform .md-field .md-textarea[disabled]{
    cursor: default;
    background: transparent;
}
.commonform .md-field .vs--disabled .vs__clear, .commonform .md-field .vs--disabled .vs__dropdown-toggle, .commonform .md-field .vs--disabled .vs__open-indicator, .commonform .md-field .vs--disabled .vs__search, .commonform .md-field .vs--disabled .vs__selected{
    cursor: default;
    background: transparent;
}
.commonform .oneflat p{
    font-size: 12px;
    font-weight: bold;
}
.error_noti{
    font-size: 10px;
    font-weight: normal;
    color: #ff0000;
    width: 100%;
    display: inline-block;
}
.checkoutpage .maincart .leftcart .checkoutsteps.step3 ul.paymenticon{
	display: flex;
    align-items: center;
	justify-content:flex-end;
}
.checkoutpage .maincart .leftcart .checkoutsteps.step3 ul.paymenticon li img{
    max-width: 50px;
    width: 50px;
    margin-left:20px;
    height: 40px;
}
.checkoutsteps .vs--unsearchable .vs__dropdown-toggle{border:1px solid #d2d2d2;}
.maincart .rightcart .rightinner .cartvalue.totalvalue span,.maincart .rightcart .rightinner .cartvalue.totalvalue p{
	font-size:16px;
}
.checkout_submit_loader{
	display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 20px;
}
.checkout_submit_loader p{
	font-weight: bold;
}
@media only screen and (max-width: 1680px) and (min-width: 1541px) {
	.checkoutpage .maincart .rightcart .cartproducts {
		width: 410px;
	}
}
@media only screen and (max-width: 1540px) and (min-width: 1441px) {
	.checkoutpage .maincart .rightcart .cartproducts {
		width: 420px;
	}
}
@media only screen and (max-width: 1199px) and (min-width: 1025px) {
    .maincart .leftcart {
        max-width: 645px;
        width: 55%;
    }
    .maincart .rightcart {
        padding: 75px 20px 75px 20px;
        width: 42%;
    }
    .maincart .leftcart .singledetails .alldetails .contentbox .savecancel a{
        margin-left:10px;
    }
    .maincart .rightcart .rightinner{
        width:100%;
    }
    .checkoutpage .maincart .leftcart .checkoutsteps{
        padding: 40px 40px 80px 0;
    }

}
@media only screen and (max-width: 1024px) and (min-width: 768px) {
	.checkoutpage header .carthead .cartlogosec img {
		width: 140px;
		height: 45px;
	}
	.checkoutpage header .cartsteps {
		max-width: 450px;
		width: 100%;
	}
	.checkoutpage header .cartsteps ul li a.backcart{
		font-size:14px;
	}
	.checkoutpage .backcart{
		font-size:13px;
		padding-bottom:0;
	}
	.checkoutpage .maincart .leftcart .checkoutsteps{
		padding-right:0;
	}
	.checkoutpage .maincart .rightcart .cartproducts{
		margin:0 auto;
		max-width:430px;
		width:100%;
	}
	.checkoutpage .maincart .leftcart hr.lasthr {
		margin-bottom: 40px;
	}
	.checkoutpage .ordershow{
		display:block;
		color: #303030;
		font-size: 16px;
		float: none;
		margin: 40px 0 0 0;
		width: 100%;
		text-align:center;
        text-decoration:none;
        background: #ececec;
        padding: 15px 10px;
        border: 1px solid #303030;
	}
	.checkoutpage .ordershow:hover{
		text-decoration:none;
	}
	.checkoutpage .ordershow .plusfil{
		width: 12px;
		margin-left: 5px;
		display: inline-block;
    }
    .checkoutpage .ordershow .minusfil {
		width: 12px;
		margin-left: 5px;
		display: none;
    }
    .checkoutpage .ordershow.minusshow .plusfil{
        display: none;
    }
    .checkoutpage .ordershow.minusshow .minusfil{
        display: inline-block;
    }
	.checkoutpage  .rightcart{
		display:none;
	}
	.maincart .leftcart{
		order:2;
	}
	.checkoutpage .maincart .rightcart{
		order:1;
	}
	.checkoutpage .maincart .leftcart .checkoutsteps.step3 ul.paymenticon{
		justify-content:flex-end;
	}
	.checkoutpage .maincart .leftcart .checkoutsteps.step3 ul.paymenticon li img{
		margin-left:20px;
		margin-right:0;
	}
	.checkoutpage .maincart .rightcart .rightinner .help_signup{
		margin-top:40px;
	}
}
@media only screen and (max-width:767px){
	.checkoutpage .maincart .leftcart .checkoutsteps{
		padding-bottom:40px;
	}
	.checkoutpage .maincart .leftcart .checkoutsteps.show{
		padding-right:0;
	}
	.checkoutpage .maincart .leftcart .checkoutsteps .commonform .row .col{
		flex-basis:100%;
	}
	.checkoutpage .maincart .leftcart .checkoutsteps .commonform .row.mobilesetup .col{
		flex-basis:50%;
		max-width:50%;
	}
	.checkoutpage .maincart .leftcart hr.lasthr {
		margin-bottom: 10px;
	}
	.checkoutpage .maincart .leftcart .btn.float-right.btn-dark {
		width: 160px;
	}
	.checkoutpage .maincart .rightcart .cartproducts .innerproducts .prdcont .samediv p,
	.checkoutpage .maincart .rightcart .cartproducts .innerproducts .prdcont .samediv span{
		font-size: 12px;
	}
	.checkoutpage .maincart .rightcart .cartproducts .innerproducts .prdcont h3{
		font-size:14px !important;
	}
	.checkoutpage .maincart .rightcart .cartproducts .innerproducts{
		padding:20px 0;
	}
	.checkoutpage .maincart .rightcart .rightinner .help_signup{
		margin-top:40px;
	}
	.checkoutpage footer .footlink{
		justify-content: center;
		height: auto;
		flex-wrap: wrap;
	}
	.checkoutpage footer .footlink ul li:last-child a {
		margin-right: 0;
	}
	.checkoutpage footer .footlink ul {
		margin-top: 12px;
		margin-bottom: 12px;
	}
	.checkoutpage header .cartsteps{
		display:none;
	}
	.checkoutpage header .carthead .cartlogosec img {
		width: 140px;
		height: 45px;
	}
	.checkoutpage .carthead .backcart{
		padding-bottom:0;
	}
	.checkoutpage .maincart .leftcart .checkoutsteps h3.mobilehead{
		display:block;
		text-align:center;
		margin-bottom:20px;
	}
	.checkoutpage .maincart .leftcart .checkoutsteps.step2, .checkoutpage .maincart .leftcart .checkoutsteps.step3{
		min-height:auto;
	}
	.checkoutpage .maincart .leftcart .checkoutsteps .md-field.md-has-password {
		margin-bottom: 0;
	}
	.checkoutpage .maincart .leftcart .checkoutsteps.step3 .what_this{
		margin-top:15px;
	}
	.checkoutpage .maincart .rightcart .cartproducts {
		width: 100%;
	}
	.checkoutpage .ordershow{
		display:block;
		color: #303030;
		font-size: 16px;
		float: none;
		margin: 40px 0 0 0;
		width: 100%;
		text-align:center;
        text-decoration:none;
        background: #ececec;
        padding: 15px 10px;
        border: 1px solid #303030;
	}
	.checkoutpage .ordershow:hover{
		text-decoration:none;
	}
	.checkoutpage .ordershow .plusfil{
		width: 12px;
		margin-left: 5px;
		display: inline-block;
    }
    .checkoutpage .ordershow .minusfil {
		width: 12px;
		margin-left: 5px;
		display: none;
    }
    .checkoutpage .ordershow.minusshow .plusfil{
        display: none;
    }
    .checkoutpage .ordershow.minusshow .minusfil{
        display: inline-block;
    }
	.checkoutpage  .rightcart{
		display:none;
	}
	.maincart .leftcart{
		order:2;
	}
	.checkoutpage .maincart .rightcart{
		order:1;
	}
	.checkoutpage .maincart .leftcart .checkoutsteps.step3 ul.paymenticon{
		justify-content:flex-start;
	}
	.checkoutpage .maincart .leftcart .checkoutsteps.step3 ul.paymenticon li img{
		margin-left:0;
		margin-right:20px;
	}
}
</style>
